import React from "react";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";

const SimpleContent = ({
  image,
  title,
  messageText,
  message,
  additionalText,
  actionButton = null,
  exitButton = null,
  additonalModalClass,
}) => {
  const { getHtmlByKey } = useContent();
  return (
    <div className={`simple-content-container ${additonalModalClass}`}>
      {image ? (
        <div className="image-container">
          <Image name={image.name} ext={image.ext} />
        </div>
      ) : null}
      <div className="simple-content-title title">{getHtmlByKey(title)}</div>
      <div className="simple-content-message">
        {messageText || getHtmlByKey(message)}
      </div>
      <div className="buttons-container">
        {exitButton}
        {actionButton}
      </div>
      {additionalText ? (
        <div className="simple-content-additional-text">
          {getHtmlByKey(additionalText)}
        </div>
      ) : null}
    </div>
  );
};

export default SimpleContent;
export { default as DefaultContainer } from "./SimpleContent";
